import { useEffect, startTransition, useRef, useState, memo } from 'react';
import { m, LazyMotion } from 'framer-motion';
const loadFeatures = () => import('~/utils/framerFeatures').then((res) => res.domAnimation);
// const loadFeatures = () => import('~/utils/framerFeatures').then((res) => res.domMax);
// import { motion, useInView } from 'framer-motion';
// import { useHydrated } from 'remix-utils/use-hydrated';

// const ImageLoader = ({ children, delay, intersectViewportCheck, childRef, style }: any) => {
const ImageLoader = memo(({ children, intersectViewportCheck, childRef, style }: any) => {
	const ref = useRef(null);
	// const isHydrated = useHydrated();
	const [loaded, setLoaded] = useState(false);
	useEffect(() => {
		if (!loaded) setLoaded(true);
		return () => {
			setLoaded(false);
		};
	}, []);

	// const isInView = useInView(ref);
	// console.log({ isInView });
	// const ImageLoader = ({ children, src, alt, delay, intersectViewportCheck, ...props }: any) => {
	const [isLoaded, setIsLoaded] = useState(false);
	const [isInView, setIsInView] = useState(false);
	const [isInViewOnPageLoad, setIsInViewOnPageLoad] = useState(false);

	//* create intersection observer, check if in viewport
	useEffect(() => {
		// console.log('observer');
		let observer = null;
		if (loaded) {
			observer = new IntersectionObserver(
				(entries) => {
					if (entries[0].isIntersecting) {
						startTransition(() => {
							setIsInView(true);
						});
					}
				},
				// { threshold: 0.5, rootMargin: '0px', root: null },
			);
			if (ref.current) {
				observer.observe(ref.current);
			}

			if (isInView && isLoaded) {
				// console.log('isInView && isLoaded');
				startTransition(() => {
					setIsInViewOnPageLoad(true);
				});
				//* kill observer
				observer.disconnect();
			} else if (isLoaded) {
				//* kill observer
				observer.disconnect();
			}
		}
		return () => {
			observer?.disconnect();
		};
	}, []);

	// React.useEffect(() => {
	//   console.log({ isInView });
	//   // if(isLoaded)
	// }, [isInView]);

	useEffect(() => {
		if (loaded) {
			try {
				if (ref.current === null) throw new Error('ref.current is null');
				if (children?.props.src === undefined) throw new Error('No src provided');

				// const img = new Image();
				// //   img.src = src;
				// img.onload = () => {
				//   setIsLoaded(true);
				// };
				// img.src = children.props.src;
				//--------------------------------------------------
				let imgRef = childRef.current;
				// if imgRef is not img -> query img
				if (imgRef.tagName !== 'IMG') {
					imgRef = imgRef.querySelector('img');
				}
				if (imgRef.complete) {
					// console.log('Image is already loaded');
					// setIsLoaded(true);
					startTransition(() => {
						setIsLoaded(true);
					});
				} else {
					imgRef.onload = () => {
						// console.log('Image is loaded');
						// setIsLoaded(true);
						startTransition(() => {
							setIsLoaded(true);
						});
					};

					imgRef.onerror = () => {
						console.error('Image failed to load');
					};
				}
			} catch (error) {
				console.error(error);
			}
		}
	}, [loaded]);

	const hidden = {
		opacity: 0,
	};

	const visible = {
		opacity: 1,
		transition: {
			duration: 0.3,
			ease: 'linear',
			//   delay: delay ? 0.3 : 0.0,
		},
	};

	const newStyle = style !== undefined ? style : { height: '100%', width: '100%' };

	return (
		// <motion.div
		<LazyMotion strict features={loadFeatures}>
			<m.div
				// id={(children?.props.src).toString()} //! is this safe?
				ref={ref}
				// style={{ ...props.style, opacity: isLoaded ? 1 : 0, transition: 'opacity 1.1s ease-in-out' }}
				//   style={{ ...props.style, opacity: isLoaded && isInView ? 1 : 0, transition: 'opacity .3s ease-in-out' }}
				// initial={visible}
				initial={hidden}
				animate={(isLoaded && !intersectViewportCheck) || isInViewOnPageLoad ? visible : hidden}
				//   whileInView={visible}
				whileInView={isLoaded && intersectViewportCheck ? visible : ''}
				viewport={{
					once: true,
					amount: 0.6,
					// margin: '200px',
				}}
				// style={
				//   style ? {...style} : { height: '100%',
				//   width: '100%',},
				// }
				style={{
					...newStyle,
				}}
				// onViewportEnter={() => {
				//   console.log('onViewportEnter');
				// }}
				//   onViewportEnter={() => setIsInView(true)}
			>
				{/* <Box component='img' src={src} alt={alt} style={{ ...props.style }} /> */}
				{children}
			</m.div>
		</LazyMotion>
		// <motion.img
		//   src={src}
		//   alt={alt}
		//   //
		//   style={{ ...props.style }}
		//   // style={{ ...props.style, opacity: isLoaded ? 1 : 0, transition: 'opacity 1.1s ease-in-out' }}
		//   //   style={{ ...props.style, opacity: isLoaded && isInView ? 1 : 0, transition: 'opacity .3s ease-in-out' }}
		//   initial={hidden}
		//   animate={isLoaded && !intersectViewport ? visible : hidden}
		//   whileInView={visible}
		//   viewport={{ once: true }}
		//   //   onViewportEnter={() => setIsInView(true)}
		// />
	);
});

export { ImageLoader };
